<template>
  <div class="content-page-index">
    <div>
      <div class="left">
        <div class="info">
          <div class="account">
            <div class="icon">
              <i class="iconfont iconkefu"></i>
            </div>
            <div>
              <p>{{$store.state.initialInfo.displayName}}</p>
              <p>台席 {{$store.state.initialInfo.extension}}</p>
            </div>
          </div>
          <!--<div class="gap"></div>-->
          <!--<div class="notifications">-->
          <!--<div>-->
          <!--<p>刘学敏 (工号1002) 将2650号工单转交给你</p>-->
          <!--<span>1分钟前</span>-->
          <!--</div>-->
          <!--<div>-->
          <!--<p>刘学敏 (工号1002) 将2650号工单转交给你</p>-->
          <!--<span>1分钟前</span>-->
          <!--</div>-->
          <!--<div>-->
          <!--<p>刘学敏 (工号1002) 将2650号工单转交给你</p>-->
          <!--<span>1分钟前</span>-->
          <!--</div>-->
          <!--</div>-->
          <div class="gap"></div>
          <div class="events">
            <div>天气信息: {{weatherInfo && weatherInfo.des}}</div>
            <div>更新时间: {{weatherInfo && weatherInfo.time}}</div>
          </div>
        </div>
        <div class="records">
          <div class="mine">
            <div class="title">
              我的通话
              <a
                href="javascript:"
                :class="{active: callStatisticDays === 1}"
                @click="callStatisticDays = 1"
              >今日</a>
              <a
                href="javascript:"
                :class="{active: callStatisticDays === 7}"
                @click="callStatisticDays = 7"
              >7日</a>
              <a
                href="javascript:"
                :class="{active: callStatisticDays === 30}"
                @click="callStatisticDays = 30"
              >30日</a>
            </div>
            <div class="sub-cont">
              <div>
                <div class="field">
                  <div class="label">在线时长</div>
                  <div
                    class="text"
                  >{{callStatistic.overall && Utils.formatTime(callStatistic.overall.TotalLoggedInTime * 1000, 1)}}</div>
                </div>
                <div class="field">
                  <div class="label">通话时长</div>
                  <div
                    class="text"
                  >{{callStatistic.overall && Utils.formatTime(callStatistic.overall.TotalTalkTime * 1000, 1)}}</div>
                </div>
                <div class="field">
                  <div class="label">话后处理</div>
                  <div
                    class="text"
                  >{{callStatistic.overall && Utils.formatTime(callStatistic.overall.TotalWorkTime * 1000, 1)}}</div>
                </div>
              </div>
              <div>
                <div class="field">
                  <div class="label">呼入电话</div>
                  <div
                    class="text"
                  >{{callStatistic.inbound && callStatistic.inbound.CallsOffered || 0}}</div>
                </div>
                <div class="field">
                  <div class="label">接听电话</div>
                  <div
                    class="text"
                  >{{callStatistic.inbound && callStatistic.inbound.CallsHandled || 0}}</div>
                </div>
                <div class="field">
                  <div class="label">未接电话</div>
                  <div
                    class="text"
                  >{{callStatistic.inbound && (callStatistic.inbound.CallsOffered - callStatistic.inbound.CallsHandled) || 0}}</div>
                </div>
                <div class="field">
                  <div class="label">呼出电话</div>
                  <div
                    class="text"
                  >{{callStatistic.outbound && callStatistic.outbound.CallsDialed || 0}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="gap"></div>
          <div class="groups">
            <div class="title">技能组通话</div>
            <div class="sub-cont">
              <div>
                <div class="field">
                  <div
                    class="label"
                  >{{callGroupStatistic.inbound && callGroupStatistic.inbound.CallsOffered || 0}}</div>
                  <div class="text">呼入</div>
                </div>
                <div class="field">
                  <div
                    class="label"
                  >{{callGroupStatistic.inbound && callGroupStatistic.inbound.CallsHandled || 0}}</div>
                  <div class="text">接听</div>
                </div>
              </div>
              <div>
                <div class="field">
                  <div
                    class="label"
                  >{{callGroupStatistic.outbound && callGroupStatistic.outbound.CallsDialed || 0}}</div>
                  <div class="text">呼出</div>
                </div>
                <div class="field">
                  <div
                    class="label"
                  >{{callGroupStatistic.inbound && (callGroupStatistic.inbound.CallsOffered - callGroupStatistic.inbound.CallsHandled) || 0}}</div>
                  <div class="text">未接</div>
                </div>
              </div>
              <div class="graph">
                <percent-circle
                  :percent="callGroupStatistic.inbound && callGroupStatistic.inbound.HandleRate || 0"
                />
                <div class="label">接听率</div>
              </div>
              <div>
                <div class="field">
                  <div
                    class="label"
                  >{{callGroupStatistic.overall && Utils.formatTime(callGroupStatistic.overall.TotalTalkTime * 1000 || 0, 1) || '0'}}</div>
                  <div class="text">总通话时长</div>
                </div>
                <div class="field">
                  <div
                    class="label"
                  >{{callGroupStatistic.overall && Utils.formatTime(callGroupStatistic.overall.AverageTalkTime * 1000 || 0, 1) || '0'}}</div>
                  <div class="text">平均通话时长</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="orders">
          <div>
            <div class="title">
              工单信息
              <a
                href="javascript:"
                :class="{active: orderStatisticDays === 1}"
                @click="orderStatisticDays = 1"
              >今日</a>
              <a
                href="javascript:"
                :class="{active: orderStatisticDays === 7}"
                @click="orderStatisticDays = 7"
              >7日</a>
              <a
                href="javascript:"
                :class="{active: orderStatisticDays === 30}"
                @click="orderStatisticDays = 30"
              >30日</a>
            </div>
            <div class="sub-cont">
              <div>
                <div class="field">
                  <div class="label">咨询</div>
                  <div class="text">{{orderStatistic.consultationCount}}</div>
                </div>
                <div class="field">
                  <div class="label">订单</div>
                  <div class="text">{{orderStatistic.orderCount}}</div>
                </div>
                <div class="field">
                  <div class="label">外呼</div>
                  <div class="text">{{orderStatistic.activeOutCount}}</div>
                </div>
              </div>
              <div>
                <div class="field">
                  <div class="label">投诉</div>
                  <div class="text">{{orderStatistic.complaintCount}}</div>
                </div>
                <div class="field">
                  <div class="label">报警</div>
                  <div class="text">{{orderStatistic.alarmCount}}</div>
                </div>
                <div class="field">
                  <div class="label">其它</div>
                  <div class="text">{{orderStatistic.otherCount}}</div>
                </div>
              </div>
              <div>
                <div class="field">
                  <div class="label">紧急呼叫</div>
                  <div class="text">{{orderStatistic.emergencyCount}}</div>
                </div>
                <div class="field"></div>
                <div class="field"></div>
              </div>
            </div>
          </div>
          <div class="gap"></div>
          <div>
            <div class="title">最近完成工单</div>
            <div class="sub-cont">
              <table>
                <tbody>
                  <tr v-for="item in recentOrders" :key="item._id.$oid">
                    <td>{{item.number}}</td>
                    <td>{{item.user_name}} {{item.title}}</td>
                    <td>通话{{item.time}}</td>
                    <td>{{item.create_time}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="statistic">
          <div>
            <div class="title">电话量趋势</div>
            <div class="sub-cont">
              <call-amount-trend-line :data="callStatisticByInterval" />
            </div>
          </div>
          <div>
            <div class="title">工单来源</div>
            <div class="sub-cont">
              <order-source-pie :percent-list="orderResources" />
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <template v-for="item in groups">
          <div class="title">技能组:{{item.skillGroupName}}</div>
          <ul>
            <li v-for="ag in item.userAgents" :key="ag.ramId">
              <i class="iconfont iconyonghu1"></i>
              <div class="name">{{ag.displayName}}</div>
              <div class="num">{{ag.dn}}</div>
              <div class="state" :class="getStateClass(ag)">{{ag.stateDesc}}</div>
            </li>
          </ul>
        </template>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import PercentCircle from '@/components/pages/index/PercentCircle'
import OrderSourcePie from '@/components/pages/index/OrderSourcePie'
import CallAmountTrendLine from '@/components/pages/index/CallAmountTrendLine'

export default {
  components: { CallAmountTrendLine, OrderSourcePie, PercentCircle },
  data() {
    return {
      callStatisticDays: 1,
      callStatistic: {},
      callGroupStatistic: {},

      orderStatisticDays: 1,
      orderStatistic: {},

      callStatisticByInterval: [],

      weatherInfo: {},

      orderResources: [],

      groups: [],
      recentOrders: []
    }
  },
  mounted() {
    this.refreshRecentOrders()
    this.refreshOrderResources()
    this.refreshAgentState()
    this.refreshWeatherInfo()
  },
  methods: {
    getStateClass(ag) {
      switch (+ag.state) {
        case 3:
          return 'color-success-light'
        case 9:
        case 10:
        case 12:
          return 'color-yellow'
        default:
          return 'color-gray'
      }
    },
    refreshAgentState() {
      this.Service.call('agent/skillGroupAgentState', 'GET').then(data => {
        this.groups = data
      })
    },
    refreshWeatherInfo() {
      this.Service.call('weather', 'GET').then(data => {
        this.weatherInfo = data || {}
      })
    },
    refreshOrderResources() {
      this.Service.call('workorder/statusStatistic', 'GET', { handleGid: this.$store.state.auth.userGid }).then(data => {
        let arr = []
        arr[0] = {
          name: '未分配',
          value: data.unassignedCount
        }
        arr[1] = {
          name: '未受理',
          value: data.notAcceptedCount
        }
        arr[2] = {
          name: '受理中',
          value: data.accepteingCount
        }
        arr[3] = {
          name: '已办结',
          value: data.successCount
        }
        arr[4] = {
          name: '已关闭',
          value: data.closedCount
        }
        this.orderResources = arr
      })
    },
    refreshRecentOrders() {
      this.Service.call('workorder', 'GET', { handleGid: this.$store.state.auth.userGid, index: 0, size: 4 }).then(data => {
        let list = data.data || []
        _.forEach(list, (item, idx) => {
          item.index = idx + 1
          item.create_time = item.create_time && item.create_time.$date
          if (item.finish_time && item.finish_time.$date) {
            item.finish_time = item.finish_time && item.finish_time.$date
            let t = item.finish_time - item.create_time
            if (t) {
              item.time = this.Utils.formatTime(t, true)
            }
          }
        })
        this.list = list
        this.recentOrders = data.data
      })
    },
    refreshCallStatistic() {
      if (this.callStatisticDays && this.$store.state.initialInfo.agentUUID) {
        let end = new Date()
        let start = new Date()
        start.setDate(start.getDate() - this.callStatisticDays + 1)
        this.Service.call('summary/agent', 'GET', {
          startTime: this.Utils.dateFormat(start, 'YYYY-MM-DD 00:00:00'),
          endTime: this.Utils.dateFormat(end, 'YYYY-MM-DD HH:mm:ss'),
          agentId: this.$store.state.initialInfo.agentUUID
        }).then(data => {
          this.callStatistic = data
        })
      }
    },
    refreshGroupCallStatistic() {
      if (this.callStatisticDays && this.$store.state.initialInfo.skillGroupId) {
        let end = new Date()
        let start = new Date()
        start.setDate(start.getDate() - this.callStatisticDays + 1)
        this.Service.call('summary/skillGroup', 'GET', {
          startTime: this.Utils.dateFormat(start, 'YYYY-MM-DD 00:00:00'),
          endTime: this.Utils.dateFormat(end, 'YYYY-MM-DD HH:mm:ss'),
          skillGroupId: this.$store.state.initialInfo.skillGroupId
        }).then(data => {
          this.callGroupStatistic = data
        })
      }
    },
    refreshOrderStatistic() {
      if (this.orderStatisticDays && this.$store.state.auth.userGid) {
        let end = new Date()
        let start = new Date()
        start.setDate(start.getDate() - this.callStatisticDays + 1)
        this.Service.call('workorder/typeStatistic', 'GET', {
          startTime: this.Utils.dateFormat(start, 'YYYY-MM-DD 00:00:00'),
          endTime: this.Utils.dateFormat(end, 'YYYY-MM-DD HH:mm:ss'),
          handleGid: this.$store.state.auth.userGid
        }).then(data => {
          this.orderStatistic = data
        })
      }
    },
    refreshCallStatisticByInterval() {
      if (this.$store.state.initialInfo.agentUUID) {
        let now = new Date()
        let start = new Date()
        start.setDate(1)
        this.Service.call('summary/agent/byInterval', 'GET', {
          startTime: this.Utils.dateFormat(start, 'YYYY-MM-DD 00:00:00'),
          endTime: this.Utils.dateFormat(now, 'YYYY-MM-DD HH:mm:ss'),
          agentId: this.$store.state.initialInfo.agentUUID
        }).then(data => {
          let arr = [{ name: '接听', value: [] }, { name: '呼出', value: [] }, { name: '未接', value: [] }]
          for (let item of data && data.intervalList && data.intervalList.AgentSummaryReport || []) {
            let x = this.Utils.dateFormat(item.Timestamp, 'MM-DD')
            arr[0].value.push({
              x, y: item.Inbound.CallsHandled || 0
            })
            arr[1].value.push({
              x, y: item.Outbound.CallsDialed || 0
            })
            arr[2].value.push({
              x, y: item.Inbound.CallsOffered - item.Inbound.CallsHandled || 0
            })
          }
          this.callStatisticByInterval = arr
        })
      }
    }
  },
  watch: {
    '$store.state.initialInfo'() {
      this.refreshCallStatistic()
      this.refreshGroupCallStatistic()
      this.refreshCallStatisticByInterval()
    },
    callStatisticDays: {
      immediate: true,
      handler(val) {
        if (val) {
          this.refreshCallStatistic()
          this.refreshGroupCallStatistic()
        }
      }
    },
    orderStatisticDays: {
      immediate: true,
      handler(val) {
        if (val) {
          this.refreshOrderStatistic()
        }
      }
    }
  }
}
</script>
